export const availableFieldFonts = [
  { id: 'Arial', label: 'Arial' },
  { id: 'Georgia', label: 'Georgia' },
  { id: 'Tahoma', label: 'Tahoma' },
  { id: 'Times-Roman', label: 'Times New Roman' },
  { id: 'Trebuchet MS', label: 'Trebuchet' },
]

export const defaultFieldFontSize = 12
export const defaultFieldFont = availableFieldFonts[0]
export const availableRoleColors = ['#6479ff', '#7ab473', 'pink', 'orange', '#b571b4', 'yellow']

export function getColorByIndex(i: number) {
  return availableRoleColors[i % availableRoleColors.length]
}

export interface RoleColor {
  role: string
  color: string
}
